import { Col } from "reactstrap";
import { SearchTabData } from "../../../../../Data/Applications/SearchResult/SearchResult";
import { AllAbout, Href } from "../../../../../Constants/Constants";
import { Link } from "react-router-dom";
import { H6, LI, UL } from "../../../../../AbstractElements";

const VideoTab1 = () => {
  return (
    <Col xxl="6" className="box-col-12">
      <H6 className="my-3">{AllAbout}</H6>
      {SearchTabData.slice(0, 3).map((item) => (
        <div className="d-flex info-block" key={item.id}>
          <iframe className="me-3" width="200" height="100" src={item.videoLink} title="videos"></iframe>
          <div className="flex-grow-1">
            <Link to={Href}>{item.url}</Link>
            <H6>{item.title}</H6>
            <div className="star-ratings">
              <UL className="search-info simple-list flex-row flex-wrap">
                <LI>{item.star}</LI>
                <LI>{item.vote}</LI>
                <LI>{item.news}</LI>
              </UL>
            </div>
          </div>
        </div>
      ))}
    </Col>
  );
};

export default VideoTab1;